<div class="form-group">
  <label>{{ label }} </label>
  <textarea
    (input)="handleInput($event)"
    [attr.maxlength]="maxLength"
    [value]="value"
    [disabled]="isDisabled"
    class="form-control"
    rows="3"
  ></textarea>
</div>
